<template>
  <div class="role-page page-padding-top">
    <top-bar :title="i18n.t('notice.title')" @back="back"></top-bar>

    <div class="notice-list">
      <div class="notice-item" v-for="(item, i) in noticeList" :key="i">
        <div class="notice-title">{{item.Title}}</div>
        <div class="notice-content" v-html="item.Content"></div>
        <div class="notice-time">{{item.CreatedAt}}</div>
        <div class="divider" v-if="i < noticeList.length - 1"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNoticeList } from '@/api/index'
import topBar from '@/components/topBar'
export default {
  components: {
    topBar
  },
  data() {
    return {
      noticeList: [
      ]
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      getNoticeList().then(res => {
        this.noticeList = res.data.Items
      })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
/* 页面整体样式 */
.role-page {
  background-color: #f8f9fa;
  padding-top: 25px !important;
  min-height: 100vh;
}

/* 公告列表容器 */
.notice-list {
  background-color: #ffffff;
  margin: 8px 0 0 0;
  padding: 0;
}

/* 单个公告项 */
.notice-item {
  padding: 24px 20px;
  position: relative;
  border-bottom: none;
}

/* 公告标题 */
.notice-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d1d1f;
  margin-bottom: 16px;
  line-height: 1.4;
  letter-spacing: -0.02em;
}

/* 公告内容 */
.notice-content {
  font-size: 16px;
  color: #515154;
  line-height: 1.6;
  margin-bottom: 20px;
  word-wrap: break-word;
  text-align: justify;
}

.notice-content::v-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 12px 0;
}

.notice-content::v-deep a {
  color: #007aff;
  text-decoration: none;
}

.notice-content::v-deep a:hover {
  text-decoration: underline;
}

/* 公告时间 */
.notice-time {
  font-size: 14px;
  color: #86868b;
  text-align: right;
  font-weight: 400;
  letter-spacing: 0.01em;
}

/* 分割线 */
.divider {
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e5e5e7, transparent);
}

/* 响应式设计 */
@media (max-width: 375px) {
  .notice-item {
    padding: 20px 16px;
  }
  
  .notice-title {
    font-size: 17px;
  }
  
  .notice-content {
    font-size: 15px;
  }
  
  .divider {
    left: 16px;
    right: 16px;
  }
}

/* 第一个项目顶部间距 */
.notice-item:first-child {
  padding-top: 28px;
}

/* 最后一个项目底部间距 */
.notice-item:last-child {
  padding-bottom: 32px;
}
</style>